import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	allCampaigns: [],
	contactsSummary: {
		progress: 0,
		production: 1000,
		notDone: 0,
		fullfillment: 0.0,
	},
};

export const dashboardCampaigns = createSlice({
	name: 'dashboard-campaigns',
	initialState,
	reducers: {
		setAllCampaigns: (state, { payload }) => ({
			...state,
			allCampaigns: payload,
		}),
		setCampaignContactsSummary: (state, { payload }) => ({
			...state,
			contactsSummary: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardCampaigns.reducer;
export const REDUCER_NAME = dashboardCampaigns.name;

export const { setAllCampaigns, setCampaignContactsSummary, reset } = dashboardCampaigns.actions;
